import { render } from "./SlowBlink.vue?vue&type=template&id=a3854166&scoped=true&ts=true"
import script from "./SlowBlink.vue?vue&type=script&lang=ts"
export * from "./SlowBlink.vue?vue&type=script&lang=ts"

import "./SlowBlink.vue?vue&type=style&index=0&id=a3854166&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3854166"]])

export default __exports__